/**
 * Timestamp formatting for values that arrive from the API, where a field typed as a date can in
 * practice be a string, be absent, or be unparseable. Every function returns null rather than a
 * placeholder, so each caller chooses its own wording for "there is no date here": a version that
 * was never updated and a source that was never run want different words for the same absence.
 */

const DAY: Intl.DateTimeFormatOptions = {year: 'numeric', month: 'short', day: 'numeric'};
const TIME: Intl.DateTimeFormatOptions = {hour: '2-digit', minute: '2-digit'};

/** The value as a Date, or null when there is nothing usable to show. */
export function toDate(value?: Date | string | null): Date | null {
    if (!value) {
        return null;
    }
    const at = value instanceof Date ? value : new Date(value);
    return Number.isNaN(at.getTime()) ? null : at;
}

/** The day alone, as the rest of the workspace shows it. */
export function formatDay(value?: Date | string | null): string | null {
    const at = toDate(value);
    return at ? at.toLocaleDateString('en-US', DAY) : null;
}

/** The day and the time, for a timestamp where the hour matters. */
export function formatDayTime(value?: Date | string | null): string | null {
    const at = toDate(value);
    return at ? `${at.toLocaleDateString('en-US', DAY)}, ${at.toLocaleTimeString('en-US', TIME)}` : null;
}
